<div class="container-b2c">
  <!-- TOPO -->
  <div class="header-b2c">
    <h1>Seus pedidos</h1>
    <div class="search-box">
      <input
        type="text"
        [(ngModel)]="searchTerm"
        placeholder="Pesquisar todos os pedidos"
        (keyup.enter)="onSearch()"
      />
      <button (click)="onSearch()" class="text-white btn-primary">
        Buscar pedidos
      </button>
    </div>
  </div>

  <!-- FILTRO -->
  <div class="filter-b2c">
    <strong>{{ totalElements }} pedidos encontrados</strong>

    <div class="filter-actions">
      <!-- PERÍODO -->
      <select
        class="select-elegant"
        [(ngModel)]="selectedPeriod"
        (change)="onPeriodChange(selectedPeriod)"
      >
        <option value="3meses">Últimos 3 meses</option>
        <option value="2026">2026</option>
        <option value="2025">2025</option>
      </select>
    </div>
  </div>

  <!-- LOADING -->
  <div *ngIf="loading" class="loading-container">
    <div class="spinner-border text-primary" role="status">
      <span class="sr-only">Carregando...</span>
    </div>
  </div>

  <!-- EMPTY STATE -->
  <div *ngIf="empty && !loading" class="empty-state">
    <h5>Nenhum pedido encontrado</h5>
    <img src="assets/empty.png" class="img-fluid" />
  </div>

  <!-- LISTA DE PEDIDOS -->
  <div *ngIf="!empty && !loading" class="orders-list">
    <div class="order-card" *ngFor="let p of pedidos">
      <div class="order-top">
        <div>
          <small>PEDIDO REALIZADO</small>
          <div>{{ formatData(p.data) }}</div>
        </div>

        <div>
          <small>TOTAL</small>
          <div>{{ formatValor(p.total) }}</div>
        </div>

        <div>
          <small>ENVIAR PARA</small>
          <div class="link-cliente">{{ getClienteNome(p) }}</div>
        </div>

        <div class="order-number">
          <small>PEDIDO No</small>
          <div>{{ p.numero_pedido || p.id }}</div>
        </div>
      </div>

      <div class="order-body">
        <div class="order-info">
          <h3>{{ getStatusPedido(p) }}</h3>
          <p>
            <strong>Pagamento</strong>:
            <span class="status">{{
              p.formaPagamento?.descricao || "Processando"
            }}</span>
          </p>
          <p *ngFor="let prod of getProdutos(p)">{{ prod }}</p>
        </div>

        <div class="order-actions">
          <button
            class="btn btn-outline-primary buttonMiddle rastreio-btn"
            (click)="showPedidoFinalizado(p)"
            title="Rastreio"
            i18n-title
            data-toggle="modal"
            data-target="#pedidoModalInfo"
          >
            <mat-icon>info_i</mat-icon>
            Informações
          </button>
          <button
            class="btn btn-outline-primary buttonMiddle rastreio-btn"
            (click)="redirectToRastreio(p)"
            title="Rastreio"
            i18n-title
          >
            <mat-icon>local_shipping</mat-icon>
            Rastreio
          </button>

          <button
            (click)="showPedido(p)"
            data-toggle="modal"
            data-target="#pedidoModalB2C"
            title="Visualizar"
            i18n-title
            class="btn btn-outline-primary buttonLeft"
          >
            <i class="icofont-search-document"></i>
            Visualizar
          </button>

          <button
            (click)="showNotaFiscal(p)"
            data-toggle="modal"
            data-target="#notaFiscalModal"
            title="Nota Fiscal"
            i18n-title
            class="btn btn-outline-primary buttonLeft"
          >
            <img src="assets/nfe-icon.svg" class="normal-icon" width="24" />
            Nota Fiscal
          </button>

          <button
            [disabled]="getStatusPedido(p) === 'PAGO'"
            (click)="gerarLinkPagamento(p)"
            title="Gerar Pagamento"
            i18n-title
            class="btn btn-outline-primary buttonLeft"
          >
            <mat-icon>attach_money</mat-icon>
            Pagar
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- PAGINAÇÃO -->
<div class="row container-b2c">
  <div class="col-lg-4 pl-0 align-itens-center">
    <label i18n>Página {{ page }} de {{ totalPages }}</label>
  </div>
  <div class="col-lg-4 pt-0">
    <!-- Paginação personalizada -->
    <div class="pagination-custom" *ngIf="totalPages > 1">
      <div class="pagination-controls">
        <!-- Primeira página -->
        <button
          class="pagination-btn"
          [class.disabled]="page === 1"
          (click)="page > 1 && loadPedidos(1)"
          [disabled]="page === 1 || loading"
          title="Primeira página"
          i18n-title
        >
          <mat-icon>keyboard_double_arrow_left</mat-icon>
        </button>

        <!-- Página anterior -->
        <button
          class="pagination-btn"
          [class.disabled]="page === 1"
          (click)="page > 1 && loadPedidos(page - 1)"
          [disabled]="page === 1 || loading"
          title="Página anterior"
          i18n-title
        >
          <mat-icon>chevron_left</mat-icon>
        </button>

        <!-- Indicador de página atual (opcional) -->
        <div class="pagination-custom" *ngIf="totalPages > 1">
          <ul class="pagination justify-content-center mb-0">
            <!-- Páginas dinâmicas -->
            <li
              class="page-item"
              *ngFor="let p of visiblePages"
              [class.active]="p === page"
            >
              <button
                class="page-link"
                (click)="loadPedidos(p)"
                [disabled]="loading"
              >
                {{ p }}
              </button>
            </li>
          </ul>
        </div>
        <button
          class="pagination-btn"
          [class.disabled]="page >= totalPages - 1"
          (click)="loadPedidos(page + 1)"
          [disabled]="page >= totalPages - 1 || loading"
          title="Primeira página"
          i18n-title
        >
          <mat-icon>chevron_right</mat-icon>
        </button>

        <!-- Página anterior -->
        <button
          class="pagination-btn"
          [class.disabled]="page >= totalPages - 1"
          (click)="loadPedidos(totalPages)"
          [disabled]="page >= totalPages - 1 || loading"
          title="Página anterior"
          i18n-title
        >
          <mat-icon>keyboard_double_arrow_right</mat-icon>
        </button>
      </div>
    </div>
  </div>
  <div class="col-lg-4 text-right pr-0 align-itens-center">
    <label i18n>{{ totalElements }} registros encontrados</label>
  </div>
</div>

<!-- MODAL DETALHE DO PEDIDO -->
<div
  class="modal fade"
  id="pedidoModalB2C"
  tabindex="-1"
  role="dialog"
  aria-hidden="true"
>
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Detalhes do Pedido</h5>
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body" *ngIf="pedido">
        <div class="pedido-detalhes">
          <p>
            <strong>Número:</strong> {{ pedido.numero_pedido || pedido.id }}
          </p>
          <p><strong>Data:</strong> {{ pedido.data }}</p>
          <p><strong>Status:</strong> {{ getStatusPedido(pedido) }}</p>
          <p><strong>Cliente:</strong> {{ getClienteNome(pedido) }}</p>
          <p><strong>Valor Total:</strong> {{ formatValor(pedido.total) }}</p>

          <hr />

          <h6>Itens do Pedido</h6>
          <table class="table table-sm" *ngIf="pedido.itens">
            <thead>
              <tr>
                <th>Produto</th>
                <th>Qtd</th>
                <th>Preço</th>
                <th>Total</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of pedido.itens">
                <td>{{ item.descricao || item.produtoDescricao }}</td>
                <td>{{ item.quantidade }}</td>
                <td>{{ formatValor(item.preco) }}</td>
                <td>{{ formatValor(item.total) }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-dismiss="modal">
          Fechar
        </button>
      </div>
    </div>
  </div>
</div>

<!-- MODAL NOTA FISCAL -->
<div
  class="modal fade"
  id="notaFiscalModal"
  tabindex="-1"
  role="dialog"
  aria-hidden="true"
>
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Nota Fiscal</h5>
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body" *ngIf="pedido">
        <div *ngIf="loadNota" class="text-center">
          <div class="spinner-border" role="status">
            <span class="sr-only">Carregando...</span>
          </div>
        </div>

        <div
          *ngIf="!loadNota && pedido.documentos && pedido.documentos.length > 0"
        >
          <div class="documento-item" *ngFor="let doc of pedido.documentos">
            <div class="doc-info">
              <p><strong>Nota:</strong> {{ doc.numero_nota }}</p>
              <p><strong>Tipo:</strong> {{ doc.tipo.toUpperCase() }}</p>
            </div>
            <div class="doc-actions">
              <button class="btn btn-primary btn-sm" (click)="printNota(doc)">
                <span *ngIf="doc.tipo?.toUpperCase() === 'DANFE'"
                  >Visualizar DANFE</span
                >
                <span *ngIf="doc.tipo?.toUpperCase() === 'XML'"
                  >Download XML</span
                >
              </button>
            </div>
          </div>
        </div>

        <div
          *ngIf="
            !loadNota && (!pedido.documentos || pedido.documentos.length === 0)
          "
          class="alert alert-info"
        >
          Nenhum documento disponível para este pedido.
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-dismiss="modal">
          Fechar
        </button>
      </div>
    </div>
  </div>
</div>

<!-- MODAL PIX/PAGAMENTO -->
<div
  class="modal fade"
  id="pixModal"
  tabindex="-1"
  role="dialog"
  aria-hidden="true"
>
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Pagamento</h5>
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body" *ngIf="qrCode">
        <div class="text-center">
          <p><strong>Escaneie o QR Code para pagar</strong></p>
          <img
            *ngIf="qrCode.image_qrcode"
            [src]="'data:image/png;base64,' + qrCode.image_qrcode"
            class="img-fluid"
            alt="QR Code Pix"
          />
          <p class="mt-3">Ou copie o código PIX:</p>
          <div class="input-group">
            <input
              type="text"
              class="form-control"
              [value]="qrCode.codigo_qrcode || ''"
              readonly
            />
            <div class="input-group-append">
              <button
                class="btn btn-outline-secondary"
                type="button"
                (click)="copyLink(qrCode.codigo_qrcode)"
              >
                Copiar
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-dismiss="modal">
          Fechar
        </button>
      </div>
    </div>
  </div>
</div>

<div
  class="modal fade"
  id="pedidoModalInfo"
  tabindex="-1"
  role="dialog"
  aria-labelledby="pedidoModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-lg" role="document">
    <div *ngIf="pedido" class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" i18n>
          Pedido #{{ pedido.pedido }} - Informações
        </h5>
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body" style="padding: 5px !important">
        <div class="row mt-2 row-id-erp">
          <div class="col-sm-4 pr-0">
            <label>Id ERP</label><br />
            {{ pedido.infos[pedido.infos.length - 1].idErp }}
          </div>
          <div class="col-sm-8">
            <label i18n>Código ERP</label><br />
            {{ pedido.infos[pedido.infos.length - 1].codigoErp }}
          </div>
        </div>
        <hr class="mt-2 mb-2 row-id-erp" />
        <div class="row mt-2 row-nfs">
          <div class="col-sm-4 pr-0">
            <label>NFS</label><br />
            {{ pedido.infos[pedido.infos.length - 1].nfs }}
          </div>
          <div class="col-sm-8">
            <label>Chave NFE</label><br />
            {{ pedido.infos[pedido.infos.length - 1].chaveNfe }}
          </div>
        </div>
        <hr class="mt-2 mb-2 row-nfs" />
        <div class="row mt-2">
          <div class="col-sm-4">
            <label>Status</label><br />
            {{ pedido.infos[pedido.infos.length - 1].statusDescricao }}
          </div>
          <div class="col-sm-8">
            <label i18n>Número Objeto</label><br />
            {{ pedido.infos[pedido.infos.length - 1].numeroObjeto }}
          </div>
        </div>
        <div class="row">
          <div class="col-12 pt-2">
            <div class="table-responsive">
              <table
                class="table table-hover table-condensed table-striped table-sm table-responsive-xs"
              >
                <thead class="table-head">
                  <tr>
                    <th><label i18n>Data</label></th>
                    <th><label i18n>Status</label></th>
                    <th><label i18n>NFS</label></th>
                    <th><label i18n>Chave NFE</label></th>
                    <th><label i18n>Número Objeto</label></th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let info of pedido.infos">
                    <td>{{ info.data }}</td>
                    <td>{{ info.statusDescricao }}</td>
                    <td>{{ info.nfs }}</td>
                    <td style="font-size: 0.6rem">{{ info.chaveNfe }}</td>
                    <td>{{ info.numeroObjeto }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
